import axios from '@axios'

export default {
  namespaced: true,
  state: {
    planos: [],
    assinaturas: [],
  },
  getters: {
    GET_PLANOS: state => state.planos,
    GET_ASSINATURAS: state => state.assinaturas,
  },
  mutations: {
    SET_PLANOS(state, planos) { state.planos = planos },
    SET_ASSINATURAS(state, assinaturas) { state.assinaturas = assinaturas },
    ADD_PLANO(state, plano) { state.planos.push(plano) },
    UPDATE_PLANO(state, plano) {
      const idx = state.planos.findIndex(p => p.id === plano.id)
      if (idx !== -1) state.planos.splice(idx, 1, plano)
    },
    REMOVE_PLANO(state, id) {
      state.planos = state.planos.filter(p => p.id !== id)
    },
    ADD_ASSINATURA(state, a) { state.assinaturas.unshift(a) },
    UPDATE_ASSINATURA(state, a) {
      const idx = state.assinaturas.findIndex(x => x.id === a.id)
      if (idx !== -1) state.assinaturas.splice(idx, 1, a)
    },
    REMOVE_ASSINATURA(state, id) {
      state.assinaturas = state.assinaturas.filter(a => a.id !== id)
    },
  },
  actions: {
    async fetchPlanos({ commit }) {
      const { data } = await axios.get('/planos')
      commit('SET_PLANOS', data)
      return data
    },
    async criarPlano({ commit }, payload) {
      const { data } = await axios.post('/planos', payload)
      commit('ADD_PLANO', data)
      return data
    },
    async atualizarPlano({ commit }, { id, ...payload }) {
      const { data } = await axios.put(`/planos/${id}`, payload)
      commit('UPDATE_PLANO', data)
      return data
    },
    async excluirPlano({ commit }, id) {
      await axios.delete(`/planos/${id}`)
      commit('REMOVE_PLANO', id)
    },
    async fetchAssinaturas({ commit }) {
      const { data } = await axios.get('/planos/assinaturas')
      commit('SET_ASSINATURAS', data)
      return data
    },
    async criarAssinatura({ commit }, payload) {
      const { data } = await axios.post('/planos/assinaturas', payload)
      commit('ADD_ASSINATURA', data)
      return data
    },
    async atualizarAssinatura({ commit }, { id, ...payload }) {
      const { data } = await axios.put(`/planos/assinaturas/${id}`, payload)
      commit('UPDATE_ASSINATURA', data)
      return data
    },
    async cancelarAssinatura({ commit }, id) {
      await axios.delete(`/planos/assinaturas/${id}`)
      commit('REMOVE_ASSINATURA', id)
    },
  },
}
